<template>
  <div id="HVUTSCategoriesList">
    <div :class="`loader${loaderClass}`" v-show="loading"></div>
    <div id="page-content-wrapper" class="admin-content-area">
      <template v-if="cantAccessPage === true">
        <div class="page-name">
          <div class="page-title"> FHUT Category List</div>
        </div>
        <div class="container-fluid">
          <div class="admin-page-content hvut-category-list">
              <data-table-filter-config :moduleName="'HVUTCategoriesList'" @cancelSelection="cancelAll" :allowSameFilter="'allow'"></data-table-filter-config>
              <section class="bg-white data-table">
                  <custom-pagination
                      :page-changed="onPageChange"
                      :per-page-changed="onPerPageChange" :moduleName="'HVUTCategoriesList'" :position="'top'">
                  </custom-pagination>
                      <vue-good-table
                          ref="listFHUTCategoryTable"
                          mode="remote"
                          title="FHUT Category List"
                          :columns="userColumns"
                          :rows="rows"
                          @on-page-change="onPageChange"
                          @on-selected-rows-change="selectionChanged"
                          @on-column-filter="onColumnFilter"
                          @on-per-page-change="onPerPageChange"
                          @on-sort-change="onSortChange"
                          :totalRows="totalRecords"
                          :pagination-options="{
                              enabled: false,
                              position: 'both',
                              perPage: perPage,
                              perPageDropdown:dropDownPerPage,
                              dropdownAllowAll: false,
                          }"
                          :search-options="{
                          enabled: false,
                          }">
                          <template slot="table-row" slot-scope="props" v-for="(row,key) in rows">
                              <div :key="key">
                                  <div v-if="props.column.field == 'action'">
                                      <template v-if="canUpdateFHUTCategory">
                                          <router-link title="Update FHUT Category" class="fp-edit" v-bind:to="{name: 'HVUTCategoriesUpdate',params:{id:props.row.id}}"></router-link>
                                      </template>
                                  </div>
                                  <div v-else>
                                      {{props.formattedRow[props.column.field]}}
                                  </div>
                              </div>
                          </template>
                      </vue-good-table>
                   <custom-pagination
                      :page-changed="onPageChange"
                      :per-page-changed="onPerPageChange">
                  </custom-pagination>
              </section>
          </div>
        </div>
      </template>
      <template v-else-if="cantAccessPage === false">
          <div class="container-fluid">
              <div class="bg-white text-center">
                  <h1>
                      Oops!</h1>
                  <h2>
                      403 </h2>
                  <div class="error-details">
                      Sorry!, You don't have permission to access this page.
                  </div>
              </div>
          </div>
      </template>
      <template v-else>
          <loading-content></loading-content>
      </template>
      <app-footer></app-footer>
    </div>
  </div>
</template>
<script>
import Vue from "vue";


import EventBus from ".././event-bus";


import {commonMixins} from '../../mixins/commonMixins';
import {dataTableMixins} from '../../mixins/dataTableMixins';
import moment from 'moment';
export default {
  name: "HVUTScheduleList",
  metaInfo: {
      // title will be injected into parent titleTemplate
      title: "FHUT Category List | " +process.env.COPYRIGHT_NAME
  },
  mixins:[commonMixins,dataTableMixins],
  data: () => ({
    permissions: [],
    cantAccessPage: "",
    canUpdateFHUTCategory:false,
    userColumns:[],
    columns: [
      {
            label: 'Actions',
            field: 'action',
            sortable:false,
            hidden:false,
        },
      {
            label: 'Code',
            field: 'code',
            filterable: true,
            fpFieldType:"text",
            hidden:false,
            filterOptions: {
                  enabled: false, // enable filter for this column
                  placeholder: "Code", // placeholder for filter input
                  filterValue: '', // initial populated value for this filter
                  trigger: "enter" //only trigger on enter not on keyup
              }
        },
        {
            label: 'Weight',
            field: 'weight',
            filterable: true,
            fpFieldType:"integer",
            hidden:false,
            filterOptions: {
                enabled: false, // enable filter for this column
                placeholder: "Weight", // placeholder for filter input
                filterValue: '', // initial populated value for this filter
                trigger: "enter" //only trigger on enter not on keyup
            }
        },
        {
            label: 'Amount',
            field: 'amount',
            filterable: true,
            fpFieldType:"integer",
            hidden:false,
            filterOptions: {
                enabled: false, // enable filter for this column
                placeholder: "Amount", // placeholder for filter input
                filterValue: '', // initial populated value for this filter
                trigger: "enter" //only trigger on enter not on keyup
            }
        },

    ],
    rows: [],
    totalRecords: 0,
    loading:false,


   }),
   watch: {
      //check permission change
      permissions: function (permissions) {
          var self = this;
          if (permissions.length > 0) {
              for (var i = 0; i < permissions.length; i++) {
                  if (permissions[i].name == 'list_hvut_schedule') {
                      self.cantAccessPage = true;
                  }
                  if (permissions[i].name == 'add_hvut_schedule') {
                      self.canUpdateFHUTCategory = true;
                  }

              }
          }

      }
  },
  mounted: function() {
      var self = this;
      self.getPermissions();
  },
  methods: {
      cancelAll: function (cancelAll) {
              this.$refs.listFHUTCategoryTable.unselectAllInternal();
            },
      selectionChanged(param) {
          var self = this;
          if(param.selectedRows.length == 100) {
            EventBus.$emit('clear-selection', false);
          } else {
            EventBus.$emit('clear-all-flags', false);
          }
          // console.log(self.computed.selectedRows);
          // var rowData = self.$refs['my-table'].selectedRows;
          // console.log(rowData);
      },
      loadList(){
          var self = this;
          self.loading = true;
          var fields = {
              page: self.serverParams.page,
              perPage: self.serverParams.perPage,
              filters: self.serverParams.columnFilters,
              sort: self.serverParams.sort,
          };
          self.firstLoad = 1;
          $.ajax({
              url: process.env.ROOT_API + "/hvut-category/list",
              type: "POST",
              crossDomain: true,
              data: fields,
              headers: this.ajxHeaders,
              dataType: "json",
              success: function (data) {
                self.loading = false;
                console.log(data.content);
                if (data.message == "success") {
                  console.log(data.content.row);
                  self.rows = data.content.row;
                  self.totalRecords = data.content.totalRecords;
                  self.filteredFlag = false;
                }
              },
              error: function (jqXHR, exception) {
                  self.loading = false;
                  self.generateStatusCodeMessage(jqXHR,false,'load-hvut-category-list')
              }
          });
      },
  }
}
</script>



// WEBPACK FOOTER //
// src/components/hvut/HVUTCategoriesList.vue